<template>
  <div class="home">
    <vue-programmatic-invisible-google-recaptcha
      ref="invisibleRecaptcha1"
      :sitekey="'6Le2gb0aAAAAAC-lBxH52eqNr1duvsYd2_ymIGip'"
      :elementId="'invisibleRecaptcha1'"
      :badgePosition="'right'"
      :showBadgeMobile="false"
      :showBadgeDesktop="true"
      @recaptcha-callback="recaptchaCallback"
    ></vue-programmatic-invisible-google-recaptcha>
    <img class="img-fluid d-none d-lg-block" src="@/assets/banner.png" alt="Banner" />
    <img class="img-fluid d-block d-lg-none" src="@/assets/banner-mobile.png" alt="Banner" />
    <div class="container">
      <div class="row">
        <div class="col pt-4 pb-5">
          <img src="@/assets/logo.png" alt="Logo" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div>
            <img class="img-fluid" src="@/assets/home-img.png" alt="Investigación de Mercado" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form mt-5">
            <p>
              Participa de nuestro "Webinar" y conoce la opinión de diferentes expertos y referentes
              de la industria.
            </p>
            <input
              :class="{ red: nameRed }"
              v-model="name"
              class="mb-3"
              placeholder="Nombre"
              type="text"
            />
            <input
              :class="{ red: emailRed }"
              v-model="email"
              class="mb-3"
              placeholder="E-mail"
              type="email"
            />
            <input
              :class="{ red: countryRed }"
              v-model="country"
              class="mb-3"
              placeholder="País"
              type="text"
            />
            <input
              :class="{ red: companyRed }"
              v-model="company"
              class="mb-3"
              placeholder="Empresa"
              type="text"
            />
            <button class="mb-4" @click="$refs.invisibleRecaptcha1.execute()">
              {{ loader ? "Cargando..." : "Participar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services.js";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      name: "",
      email: "",
      country: "",
      company: "",
      loader: false,
      nameRed: false,
      emailRed: false,
      countryRed: false,
      companyRed: false,
    };
  },
  methods: {
    send() {
      if (!this.loader) {
        if (this.name !== "") this.nameRed = false;
        else this.nameRed = true;

        if (this.email !== "") this.emailRed = false;
        else this.emailRed = true;

        if (this.country !== "") this.countryRed = false;
        else this.countryRed = true;

        if (this.company !== "") this.companyRed = false;
        else this.companyRed = true;

        if (this.name !== "" && this.email !== "" && this.country !== "" && this.country !== "") {
          if (this.email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
            this.loader = true;
            api
              .post(
                "user/lead",
                {
                  name: this.name,
                  email: this.email,
                  country: this.country,
                  company: this.company,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((r) => {
                if (r.status === 200) {
                  this.name = "";
                  this.email = "";
                  this.country = "";
                  this.company = "";
                  this.$toast.success("Enviado con éxito");
                }
                this.loader = false;
              })
              .catch(() => {
                this.$toast.error("Algo salió mal. Inténtalo de nuevo más tarde");
                this.loader = false;
              });
          } else {
            this.emailRed = true;
            this.$toast.error("El correo electrónico no es válido");
          }
        } else {
          this.$toast.error("Por favor rellena todos los campos");
        }
      }
    },
    recaptchaCallback() {
      this.send();
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
  }
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    @include typography1(20, 24.72, $white, 700);
    max-width: 400px;
    text-align: center;
    margin-bottom: 40px;
  }
  input {
    @include input-home;
    @include focus;
  }
  button {
    margin-top: 25px;
    @include red-button;
    @include focus;
  }
}

.red {
  box-shadow: 0 0 0 4px rgba(226, 77, 74, 0.8) !important;
}
</style>
